import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "src/components/layout/website/Layout";
import Button from "src/components/ui/Button";

const PricingPage: React.FC = () => {
  const navigate = useNavigate();

  const plans = [
    {
      name: "Starter",
      price: "₹499 / month",
      features: [
        "Up to 3 users",
        "Basic inventory tracking",
        "Standard reports",
        "Email support",
      ],
    },
    {
      name: "Business",
      price: "₹999 / month",
      features: [
        "Up to 10 users",
        "Advanced analytics",
        "Multi-tenant access",
        "Priority support",
      ],
    },
    {
      name: "Enterprise",
      price: "Custom",
      features: [
        "Unlimited users",
        "Custom integrations",
        "Dedicated account manager",
        "On-premise support",
      ],
    },
  ];

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 py-20 px-6 text-center">
        <h1 className="text-4xl font-bold text-indigo-600 mb-8">
          Pricing Plans
        </h1>
        <p className="text-gray-600 mb-12">
          Choose the plan that fits your business size and scale anytime.
        </p>
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
          {plans.map((p, i) => (
            <div
              key={i}
              className="bg-white p-8 rounded-xl shadow hover:shadow-lg transition"
            >
              <h2 className="text-2xl font-semibold mb-4">{p.name}</h2>
              <p className="text-indigo-600 text-xl font-bold mb-6">
                {p.price}
              </p>
              <ul className="text-gray-600 text-sm space-y-2 mb-8">
                {p.features.map((f, i) => (
                  <li key={i}>✅ {f}</li>
                ))}
              </ul>

              <Button onClick={() => navigate("/pricing")}>Get Started</Button>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default PricingPage;
